import React from 'react';
import {useDispatch} from 'react-redux';
import './DeleteSuccess.scss';
import {
  AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS,
  closeModal,
} from '../../../redux/modules/modals/modals.module';
import successImg from '../../../assets/images/success.png';

const DeleteSuccess = ({ type = 'REDEEM' }) => {
  const dispatch = useDispatch();
  const modalName = type === 'REDEEM' ? 'Automatic Sell' : 'Automatic Exchange';
  return (
    <div>
      <div className="defer-delete-success-image-container">
        <img src={successImg} alt="success" />
      </div>
      <div className="defer-delete-success-title">
        Changes to your {modalName} have been submitted.
      </div>
      <div className="defer-delete-success-button-container">
        <button
          buttontype="primary"
          id="defer-delete-sucess"
          size="medium"
          className="defer-delete-success-button"
          stylename="defer-delete-success-button"
          onClick={(e) => {
            dispatch(closeModal(AUTOMATIC_TRANSACTION_DEFER_DELETE_SUCCESS));
          }}
        >
          Ok
        </button>
      </div>
    </div>
  );
};

export default DeleteSuccess;
